<template>
  <div class="user-manager-container">
    <!-- 头部菜单 -->
    <div class="menu-tabs">
      <el-button
        v-for="item in menuList"
        :key="item.type"
        :type="activeType === item.type ? 'primary' : 'default'"
        @click="switchType(item.type)"
      >
        {{ item.name }}
      </el-button>
    </div>

    <!-- 子组件：用户列表 -->
    <UserList
      :user-type="activeType"
      :refresh-key="refreshKey"
      @refresh="handleRefresh"
    />
  </div>
</template>

<script>
// 子组件
import UserList from './UserList.vue'

export default {
  name: 'UserManager',
  components: { UserList },
  data() {
    return {
      // 菜单
      menuList: [
        { name: '中台用户', type: 'admin' },
        { name: '学校用户', type: 'school' },
        { name: '家长', type: 'parent' },
        { name: '学生', type: 'student' },
        { name: '教育局用户', type: 'edu' },
      ],
      activeType: 'admin', // 默认选中
      refreshKey: 0, // 刷新子组件用
    }
  },
  methods: {
    // 切换类型
    switchType(type) {
      this.activeType = type
      this.refreshKey++
    },
    // 接收子组件刷新
    handleRefresh() {
      this.refreshKey++
    },
  },
}
</script>

<style scoped>
.user-manager-container {
  padding: 20px;
}
.menu-tabs {
  margin-bottom: 20px;
}
.menu-tabs .el-button {
  margin-right: 10px;
}
</style>